const buildFieldName = ({ name, index }) => {
    return (!index && index !== 0) ? name : (name + "[" + index + "]");
};

const findFieldError = (errors, { name, index }) => {
    return (!index && index !== 0) ? errors[name] : errors[name] ? errors[name][index] : errors[name];
};


//classify the units by type or category
const buildTypeList = (unitTypeList) => {
    /*const typeList = [
        { type: "A", name: "拼音练习", list: [] },
        { type: "B", name: "单字或者词组练习", list: [] },
        { type: "C", name: "手写练习", list: [] },
        { type: "D", name: "单句练习", list: [] },
        { type: "E", name: "语法练习", list: [] },
        { type: "F", name: "对话练习", list: [] },
        { type: "G", name: "阅读练习", list: [] },
        { type: "H", name: "慕课视频模板", list: [] },
        { type: "I", name: "测试答题模板", list: [] },
    ];

    //分类取出来
    for (let i in unitTypeList) {
        switch (unitTypeList[i].category) {
            case 1:
                typeList[0].list.push(unitTypeList[i]);
                break;
            case 2:
                typeList[1].list.push(unitTypeList[i]);
                break;
            case 3:
                typeList[2].list.push(unitTypeList[i]);
                break;
            case 4:
                typeList[3].list.push(unitTypeList[i]);
                break;
            case 5:
                typeList[4].list.push(unitTypeList[i]);
                break;
            case 6:
                typeList[5].list.push(unitTypeList[i]);
                break;
            case 7:
                typeList[6].list.push(unitTypeList[i]);
                break;
            case 8:
                typeList[7].list.push(unitTypeList[i]);
                break;
            case 9:
                typeList[8].list.push(unitTypeList[i]);
                break;
            default:
                break;
        }
    }*/

    unitTypeList.sort((a, b) => {
        return a.id > b.id ? 1 : -1;
    });
    return unitTypeList;
}

const hasReferenceAnswer = (_data) => {
    let data = typeof(_data) === 'string' ? JSON.parse(_data) : _data;
    if (data.referenceAnswers && data.referenceAnswers.find(s => s && (s.image || s.text))) {
        return true;
    }

    if (data.units) {
        for (let i = 0; i < data.units.length; ++i) {
            let it = JSON.parse(data.units[i].data);
            if (it.referenceAnswers && it.referenceAnswers.find(s => s && (s.image || s.text))) {
                return true;
            } else if (it.practices) {
                for (let i = 0; i < it.practices.length; ++i) {
                    let subPractice = it.practices[i];
                    if (subPractice.referenceAnswer && (subPractice.referenceAnswer.image || subPractice.referenceAnswer.text)) {
                        return true;
                    }
                }
            }
        }
    }

    if (data.practices) {
        for (let i = 0; i < data.practices.length; ++i) {
            let it = data.practices[i];
            if (it.referenceAnswer && (it.referenceAnswer.image || it.referenceAnswer.text)) {
                return true;
            }
        }
    }
    return false;
};

const isSubjectiveMode = (unit) => {
    if (unit.isSubjective) {
        return true;
    }
    if (unit.answerType && unit.answerType !== 1) {
        return true;
    }
    return false;
};

export {
    buildFieldName,
    findFieldError,
    buildTypeList,
    hasReferenceAnswer,
    isSubjectiveMode
};
